var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticStyle: { "padding-inline-start": "0px", "list-style": "none" } },
    _vm._l(_vm.attentions, function(studentAttention) {
      return _c(
        "li",
        { key: studentAttention.id },
        [
          _c(
            "attentions-by-type-item",
            {
              staticStyle: { margin: "10px 0" },
              attrs: { "bordered-header": true, attention: studentAttention },
              on: { "finish-attention": _vm.finishAttention }
            },
            [
              _c("template", { slot: "subheader" }, [
                _vm._v(_vm._s(_vm.attentionStatus(studentAttention)))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "meta-list" }, [
                _c("hr"),
                _vm._v(" "),
                studentAttention.participationOf &&
                studentAttention.participationOf["comment"]
                  ? _c("div", { staticClass: "meta-item" }, [
                      _c(
                        "span",
                        { staticClass: "meta-name has-text-weight-bold" },
                        [_vm._v("Resultado:")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "meta-value" }, [
                        _vm._v(
                          _vm._s(studentAttention.participationOf["comment"])
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                studentAttention.status !== "FAILED" &&
                studentAttention.participationOf &&
                studentAttention.participationOf["evaluation"]
                  ? _c("div", { staticClass: "meta-item" }, [
                      _c(
                        "span",
                        { staticClass: "meta-name has-text-weight-bold" },
                        [_vm._v("Evaluación:")]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "meta-value" }, [
                        _c("button", { staticClass: "emotion" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.evaluationIconScore[
                                  studentAttention.participationOf["evaluation"]
                                ]
                              ) +
                              "\n            "
                          )
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "meta-item" }, [
                  _c(
                    "span",
                    { staticClass: "meta-name has-text-weight-bold" },
                    [_vm._v("Fecha de cierre:")]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "meta-value" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("formatStandardDate")(
                          studentAttention.performedAt
                        )
                      )
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "meta-item" }, [
                  _c(
                    "span",
                    { staticClass: "meta-name has-text-weight-bold" },
                    [_vm._v("Responsable de cierre:")]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "meta-value" }, [
                    _vm._v(_vm._s(_vm.finishedByUser(studentAttention)))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "description" }, [_c("i")])
            ],
            2
          )
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }